import { render } from "./InputTags.vue?vue&type=template&id=c603cda4"
import script from "./InputTags.vue?vue&type=script&lang=js"
export * from "./InputTags.vue?vue&type=script&lang=js"

import "./InputTags.vue?vue&type=style&index=0&id=c603cda4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__